import templateData from './getTemplateData';

export const appendCdnHostName = (url) => {
  return `${templateData.cdnHostName || 'https://www.paypalobjects.com'}${url}`;
};
